import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  min-width: 150px;
  min-height: 150px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
`;

export const Header = styled.div`
  width: 100%;
  height: 3.3em;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  color: #7a7a7a;
  background-color: #f4f7fe;
  border-radius: 4px;

  span {
    font-size: 1.3em;
    font-weight: bold;
    color: #000;
    text-align: center;
    text-overflow: ellipsis;
  }
`;

export const Body = styled.div`
  position: fixed;
  background: white;
  padding: 0px;
  padding-top: 18px;
  padding-bottom: 20px;

  display: flex;
  flex-direction: column;
  align-items: center;

  max-width: 23em;
  max-height: 18em;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 4px;
`;

export const Message = styled.div`
  width: 100%;
  height: 50%;

  display: flex;
  flex-direction: center;
  justify-content: center;
  margin-top: 4px;

  span {
    color: black;
    font-size: 13px;
    text-align: center;
    text-overflow: ellipsis;

    width: 21em;
  }
`;

export const Name = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 80px;

  color: black;
  font-size: 16px;
  font-weight: bold;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 40px;

  p {
    color: #565757;
    font-size: 13px;
    text-align: center;
    text-overflow: ellipsis;
  }
`;
